import { getCheckedInputValues } from "../form/form";

function parseList(value) {
	if (!value) {
		return [];
	}

	return value
		.split("|")
		.map((item) => item.trim())
		.filter(Boolean);
}

function setSelectValue($select, value) {
	if (!$select || !value) {
		return;
	}

	const hasOption = Array.from($select.options).some(
		(option) => option.value === value
	);

	if (hasOption) {
		$select.value = value;
	}
}

function setMultiSelectValues($scope, values) {
	if (!$scope || !Array.isArray(values) || !values.length) {
		return;
	}

	const selectedValues = new Set(values);

	$scope.querySelectorAll(".bc-multi-select__input").forEach(($input) => {
		$input.checked = selectedValues.has($input.value);
	});
}

export function readInitialState($module) {
	const {
		searchFilterInitialCategory = "",
		searchFilterInitialCountry = "",
		searchFilterInitialCounty = "",
		searchFilterInitialDivision = "",
		searchFilterInitialDublinArea = "",
		searchFilterInitialApplied = "false"
	} = $module.dataset;

	return {
		category: searchFilterInitialCategory,
		country: searchFilterInitialCountry,
		county: searchFilterInitialCounty,
		division: parseList(searchFilterInitialDivision),
		dublinArea: parseList(searchFilterInitialDublinArea),
		applied: searchFilterInitialApplied === "true"
	};
}

export function applyInitialState(
	initialState,
	{ $category, $country, $county, $divisionSection, $dublinAreaSection }
) {
	setSelectValue($category, initialState.category);
	setSelectValue($country, initialState.country);
	setSelectValue($county, initialState.county);
	setMultiSelectValues($divisionSection, initialState.division);
	setMultiSelectValues($dublinAreaSection, initialState.dublinArea);
}

export function getActiveFilterCount({
	$category,
	$country,
	$county,
	$divisionSection,
	$dublinAreaSection
}) {
	const hasCategory = Boolean($category?.value);
	const isIrelandSelected = $country?.value === "ireland";
	const hasCountry = Boolean($country?.value);
	const hasCounty = Boolean($county?.value);
	const isDublinSelected = $county?.value === "dublin";
	const hasDivision =
		getCheckedInputValues($divisionSection, ".bc-multi-select__input", {
			excludeDisabled: true
		}).length > 0;
	const hasDublinArea =
		getCheckedInputValues($dublinAreaSection, ".bc-multi-select__input", {
			excludeDisabled: true
		}).length > 0;

	let count = 0;

	if (hasCategory) {
		count += 1;
	}

	if (hasCountry) {
		count += 1;
	}

	if (isIrelandSelected && hasCounty) {
		count += 1;
	}

	if (hasCategory && hasDivision) {
		count += 1;
	}

	if (isIrelandSelected && isDublinSelected && hasDublinArea) {
		count += 1;
	}

	return count;
}
